import React, { useState, useEffect } from "react";
import { Table, Icon, Input } from "semantic-ui-react";
import { map } from "lodash";
import { Button } from "semantic-ui-react";
import "./TableManagers.css";
import { Tooltip } from "react-tooltip";
import axios from "axios";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { useAuth } from "../../../hook/userAuth";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export function TableManagers(props) {
  const { managers, deleteManager, updateManager, usuarioActual, onRefetch } =
    props;
  const itemsPerPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [realTimeSearch, setRealTimeSearch] = useState("");
  const { auth } = useAuth();

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
  }, [searchText]);

  const handleRealTimeSearchChange = (value) => {
    setRealTimeSearch(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    setSearchText(realTimeSearch.toLowerCase());
  }, [realTimeSearch]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredManagers = managers.filter((user) =>
    user.first_name.toLowerCase().includes(searchText.toLowerCase())
  );

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
    if (searchText === "") {
      setCurrentPage(1);
    }
  }, [searchText, setCurrentPage]);

  useEffect(() => {
    const lastPage = Math.ceil(filteredManagers.length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  }, [filteredManagers, currentPage, setCurrentPage]);

  const paginatedManagers = filteredManagers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const desasignar_rol = async (datosUsuario) => {
    const confirmMessage = `¿Seguro que desea desasignarle el rol de directivo a este usuario: ${datosUsuario.curp}?`;
    const result = await Swal.fire({
      text: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const url = `${BASE_API}/api/users/${datosUsuario.id}/`;
        const headers = {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        };

        // Solo incluimos los campos que queremos actualizar
        const updatedData = {
          is_superuser: false,
          cargo_asignado: null,
        };

        const response = await axios.patch(url, updatedData, { headers });
        onRefetch();
        return response.data;
      } catch (error) {
        if (error.response && error.response.status === 400) {
          toast.error("Error al intentar desasignar el rol de administrador");
        }
        throw error;
      }
    }
  };

  return (
    <div>
      <div className="buscar">
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por nombre"
          value={realTimeSearch}
          onChange={(e) => handleRealTimeSearchChange(e.target.value)}
          className="busper"
        />
      </div>
      <Table className="table-users-admin">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>USUARIO</Table.HeaderCell>
            <Table.HeaderCell>CURP</Table.HeaderCell>
            <Table.HeaderCell>NOMBRE</Table.HeaderCell>
            <Table.HeaderCell>APELLIDOS</Table.HeaderCell>
            <Table.HeaderCell>CATEGORIA</Table.HeaderCell>
            <Table.HeaderCell>GRADO ACADEMICO</Table.HeaderCell>
            <Table.HeaderCell>CARGO</Table.HeaderCell>
            <Table.HeaderCell>TELEFONO</Table.HeaderCell>
            <Table.HeaderCell>ESTADO DE USUARIO</Table.HeaderCell>
            <Table.HeaderCell>DOCENTE</Table.HeaderCell>
            <Table.HeaderCell>ACCIONES</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {map(paginatedManagers, (user, index) => (
            <Table.Row key={index}>
              <Table.Cell>{user.username}</Table.Cell>
              <Table.Cell>{user.curp}</Table.Cell>
              <Table.Cell>{user.first_name}</Table.Cell>
              <Table.Cell>
                {user.last_name} {user.apellido_materno}
              </Table.Cell>
              <Table.Cell>{user.categoria_data?.descripcion}</Table.Cell>
              <Table.Cell>{user.grado_estudio}</Table.Cell>
              <Table.Cell>{user.cargo_data?.descripcion}</Table.Cell>
              <Table.Cell>{user.telefono}</Table.Cell>
              <Table.Cell className="status">
                {user.is_active ? "Activo" : "No activo"}
              </Table.Cell>
              <Table.Cell className="status">
                {user.es_docente ? "Si" : "No"}
              </Table.Cell>
              <Actions
                manager={user}
                deleteManager={deleteManager}
                updateManager={updateManager}
                usuarioActual={usuarioActual}
                desasignar_rol={desasignar_rol}
              />
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(managers.length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(managers.length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(managers.length / itemsPerPage);
            // para evitar renderizar el botón si solo hay una página
            if (Math.ceil(managers.length / itemsPerPage) === 1) {
              return null;
            }
            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            } else if (showStartEllipsis && pageNumber === 1) {
              return (
                <Button key="startEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            } else if (
              showEndEllipsis &&
              pageNumber === Math.ceil(managers.length / itemsPerPage)
            ) {
              return (
                <Button key="endEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            }
            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}
function Actions(props) {
  const {
    manager,
    // eslint-disable-next-line
    deleteManager,
    updateManager,
    usuarioActual,
    desasignar_rol,
  } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Actualizar datos"
          icon
          className="yellow"
          onClick={() => {
            updateManager(manager);
          }}
        >
          <Icon name="pencil" style={{ color: "white" }}></Icon>
        </Button>

        {/**{manager.username !== usuarioActual.username && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Eliminar directivo"
            icon
            negative
            onClick={() => {
              deleteManager(manager);
            }}
          >
            <Icon name="trash" style={{ color: "white" }}></Icon>
          </Button>
        )} */}

        {manager.username !== usuarioActual.username && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Desasignar rol administrador"
            icon
            negative
            onClick={() => {
              desasignar_rol(manager);
            }}
          >
            <Icon name="minus circle" style={{ color: "white" }}></Icon>
          </Button>
        )}
      </div>
      <Tooltip id="my-tooltip" />
    </Table.Cell>
  );
}
